<template>
  <loading-view :loading="activity === null">
    <div class="container mt-4" v-if="activity">
      <div class="row mb-8">
        <button @click="goBack" class="button mb-6">
          {{ trans('activity.go_back') }}
        </button>

        <button
          @click="goPrevious"
          class="button button_secondary mb-6 ml-6"
          :disabled="activity.previous === null"
          :style="activity.previous === null ? 'cursor: not-allowed' : ''"
        >
          {{ trans('pagination.previous') }}
        </button>
        <button
          @click="goNext"
          class="button button_secondary mb-6 ml-6"
          :disabled="activity.next === null"
          :style="activity.next === null ? 'cursor: not-allowed' : ''"
        >
          {{ trans('pagination.next') }}
        </button>

        <button
          type="button"
          v-if="activity.status === 'failed' && !activity.is_repeated"
          @click="retryJob"
          class="cursor-pointer btn btn-default btn-primary inline-flex items-center relative ml-auto"
        >
          <span> {{ trans('common.retry') }} </span>
        </button>

        <button
          type="button"
          v-if="activity.is_repeated"
          disabled
          class="cursor-pointer btn btn-default btn-info inline-flex items-center relative ml-auto"
        >
          <span> {{ trans('activity.repeated') }} </span>
        </button>
      </div>
      <p class="h3">
        {{ activity.flow_name }}
        <small v-if="activity.application_name" class="text-muted">({{ activity.application_name }})</small>
      </p>
      <div
        v-if="activity.error_message"
        class="row alert"
        :class="{
            'alert-info': activity.status === 'debug' || activity.status === 'pending',
            'alert-success': activity.status === 'success',
            'alert-danger': activity.status === 'failed',
            'alert-warning': activity.status === 'pause' || activity.status === 'warning',
          }"
      >
        {{ activity.error_message }}
      </div>
      <div v-for="product in eventData" :key="product.id" class="card row card-block">
        <div class="card-body">
          <div class="card-title d-flex justify-content-between">
            <div class="bd-highlight">{{ trans('common.id') }}: {{ product.id }}</div>
            <div class="bd-highlight">{{ trans('common.action') }}: {{ product.action }}</div>
            <div class="bd-highlight">
              {{ trans('common.status') }}: {{ product.status ? trans(`activity.status.${product.status}`) : '-' }}
            </div>
          </div>
          <div
            v-if="product.message"
            class="row alert"
            :class="{
                'alert-info': activity.status === 'debug' || activity.status === 'pending',
                'alert-success': activity.status === 'success',
                'alert-danger': activity.status === 'failed',
                'alert-warning': activity.status === 'pause' || activity.status === 'warning',
              }"
            v-html="product.message"
          />

          <div v-if="isNotEmpty(product.data)">
            <div class="card-text col-12 my-4">
              <vue-json-pretty :path="'res'" :data="product.data"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </loading-view>
</template>

<script>
import DashboardLayout from "@/Layouts/DashboardLayout";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import Swal from "sweetalert2";

export default {
  name: "ShowActivity",

  layout: DashboardLayout,

  components: {
    VueJsonPretty
  },

  props: {
    user: Object
  },

  data() {
    return {
      activity: null,
    };
  },

  async beforeMount() {
    await this.prepareData();
  },

  computed: {
    eventData() {
      return this.activity['event_data'] || [];
    },
  },

  methods: {
    isNotEmpty(collection) {
      if (Array.isArray(collection) || typeof collection === 'object') {
        return Object.keys(collection).length > 0;
      }
      return false;
    },
    goBack() {
      let parameters = {
        user: this.user.id,
        integration: this.activity.user_integration_id,
        integrationFlow: this.activity.user_integration_flow_id,
        activityId: this.$route().params.activityId,
        perPage: this.$route().params.perPage ? parseInt(this.$route().params.perPage) : 15,
        page: this.$route().params.page ? parseInt(this.$route().params.page) : 1
      }

      this.$inertia.visit(this.$route('dashboard.user.integrations.flows.activity', parameters))
    },

    pushRouter(activity) {
      this.$inertia.visit(
        this.$route('dashboard.user.integrations.flows.activities.show', {
          user: this.user.id,
          integration: activity.user_integration_id,
          integrationFlow: activity.user_integration_flow_id,
          activity: activity.id
        })
      )
    },

    async goPrevious() {
      this.pushRouter(this.activity.previous);
    },

    async goNext() {
      this.pushRouter(this.activity.next);
    },

    retryJob() {
      axios
        .post(`/api/integrations/${this.$route().params.integration}/flows/${this.$route().params.integrationFlow}/activity/${this.$route().params.activity}/retry`)
        .then(({data}) => {
          this.activity = data.activity;

          Swal.fire({
            text: data.message,
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },

    async prepareData() {
      await axios
        .get(`/api/integrations/${this.$route().params.integration}/flows/${this.$route().params.integrationFlow}/activity/${this.$route().params.activity}`)
        .then(({data}) => {
          this.activity = data.activity;
        })
        .catch(error => {
          Swal.fire({
            text: error.response.data.message,
            icon: 'error',
            showConfirmButton: false,
          });
        });
    },
  },
}
</script>

<style>
.card-block {
  max-width: 1140px !important;
  display: inline-block;
  width: 100%;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
</style>
